/**
 * Created by jiachenpan on 16/11/18.
 */

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function isValidname(str) {
  if (!str.trim()) return false
  if (!/^[a-zA-Z]+/.test(str)) return false
  if (str.length <= 0 || str.length > 20) return false
  return true
}

export function signUpEmailCheck(str) {
  if (!str.trim()) return 'Email cannot be empty'
  const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
  if (!reg.test(str)) return 'The mailbox format is incorrect.'
}

export function signUpUserNameCheck(str) {
  if (!str.trim()) return 'User name cannot be empty'
  if (str.length < 6) return 'User name cannot be less than 6 digits'
}

export function signUpPassCheck(str) {
  const reg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}')
  if (!str.trim()) return 'password can not be blank'
  if (!reg.test(str)) return 'The password must contain letters, numbers, and special characters, at least 8 characters, and up to 30 characters.'
}



// WEBPACK FOOTER //
// ./src/utils/validate.js